<div class="row text-center mb-2">
	<span class="theme-main-color fw-bold fs-5">
		Taux de missions assignées
	</span>
</div>
<div class="row h-100" *ngIf="isSESSAD">
	<div class="col-12 col-lg-3" *ngIf="lsfStats?.numberFormation > 0">
		<div echarts [options]="chartOptionSatisfactionLSF"></div>
	</div>
	<div
		*ngIf="lsfStats?.numberFormation < 1"
		class="col-12 col-lg-3 d-flex align-items-center justify-content-center"
	>
		<span class="mb-5 text-center">Pas de données pour LSF</span>
	</div>

	<div class="col-12 col-lg-3" *ngIf="lpcStats?.numberFormation > 0">
		<div echarts [options]="chartOptionSatisfactionLPC"></div>
	</div>
	<div
		*ngIf="lpcStats?.numberFormation < 1"
		class="col-12 col-lg-3 d-flex align-items-center justify-content-center"
	>
		<span class="mb-5 text-center">Pas de données pour LPC</span>
	</div>

	<div class="col-12 col-lg-3" *ngIf="pdnStats?.numberFormation > 0">
		<div echarts [options]="chartOptionSatisfactionPDN"></div>
	</div>
	<div
		*ngIf="pdnStats?.numberFormation < 1"
		class="col-12 col-lg-3 d-flex align-items-center justify-content-center"
	>
		<span class="mb-5 text-center">Pas de données pour Prise de notes</span>
	</div>

	<div class="col-12 col-lg-3" *ngIf="oralStats?.numberFormation > 0">
		<div echarts [options]="chartOptionSatisfactionOral"></div>
	</div>
	<div
		*ngIf="oralStats?.numberFormation < 1"
		class="col-12 col-lg-3 d-flex align-items-center justify-content-center"
	>
		<span class="mb-5 text-center">Pas de données pour Oral</span>
	</div>
</div>
<div class="row h-100" *ngIf="isSAAD">
	<div class="col-12 col-lg-4" *ngIf="globalStats?.numberFormation > 0">
		<div echarts [options]="chartOptionSatisfactionSAAD"></div>
	</div>
	<div
		*ngIf="!globalStats || globalStats.numberFormation < 1"
		class="col-12 col-lg-3 d-flex align-items-center justify-content-center"
	>
		<span class="mb-5 text-center">Pas de données</span>
	</div>
</div>
